import Image from "next/image";

interface LoaderProps {
      fullScreen?: boolean;
}

const Loader = ({ fullScreen = false }: LoaderProps) => {
      return (
            <div className={`loader-kiwilog ${fullScreen ? 'fixed inset-0 flex items-center justify-center bg-white/80 z-50' : ''}`}>
                  <Image src="/loader.png" alt="KiwiLog" width={100} height={100} className="animate-pulse" />
            </div>
      );
};

export default Loader;
